import deepmerge from 'deepmerge';

import main from './main';

const actionaidgs = {
  palette: {
    primary: {
      main: '#ED0506'
    },
    secondary: {
      main: '#FEEBEB'
    }
  }
};

export default deepmerge(main, actionaidgs);
